import { Game } from 'config/types/game'
import { BlogTag, HunnyPost } from 'config/types/hunnyBlog'
import { BaseResponse, Paging } from 'services/types'

export const parsePost = (post): HunnyPost => ({
  id: post.id,
  title: post.title,
  imageThumbnail: post.image_url,
  slug: post.slug,
  createdTime: post.from_time * 1000,
  tags: post.category_infos.map((category) => ({
    tagId: category.category_id || null,
    content: category.category_name,
    tagSlug: category.slug,
  })),
  content: post.content,
})

export const HunnyBlogListMapper = (rawResponse: string): BaseResponse<Paging<HunnyPost>> => {
  const response: BaseResponse<any> = JSON.parse(rawResponse)

  if (!response) {
    return {
      code: 'error',
      data: null,
    }
  }

  return {
    code: response.code,
    message: response.message || null,
    data: {
      ...response.data,
      items: response.data?.items.map((item) => parsePost(item)) || [],
    },
  }
}

export const HunnyBlogDetailsMapper = (rawResponse: string): BaseResponse<HunnyPost> => {
  const response: BaseResponse<any> = JSON.parse(rawResponse)

  if (!response) {
    return {
      code: 'error',
      data: null,
    }
  }

  const postDetails = response.data

  return {
    code: response.code,
    message: response.message || null,
    data: postDetails
      ? {
          id: postDetails.id,
          slug: postDetails.slug,
          title: postDetails.title,
          bannerUrl: postDetails.image_url,
          content: postDetails.content,
          tags: postDetails.category_infos.map((category) => ({
            tagId: category.category_id || null,
            content: category.category_name,
            tagSlug: category.slug,
          })),
          keyWords: postDetails.key_words,
          createdTime: postDetails.create_time * 1000,
          imageThumbnail: '',
        }
      : null,
  }
}

export const HunnyBlogTagsMapper = (rawResponse: string): BaseResponse<BlogTag[]> => {
  const response: BaseResponse<any> = JSON.parse(rawResponse)

  if (!response) {
    return {
      code: 'error',
      data: null,
    }
  }

  return {
    code: response.code,
    message: response.message || null,
    data: response.data
      ? response.data.items.map((tag) => ({
          tagId: tag.id || null,
          content: tag.name,
          tagSlug: tag.slug,
        }))
      : [],
  }
}

export const HunnyBlogRecommendGamesMapper = (rawResponse: string): BaseResponse<Game[]> => {
  const response: BaseResponse<any> = JSON.parse(rawResponse)

  if (!response) {
    return {
      code: 'network_error',
      data: null,
    }
  }

  return {
    code: response.code,
    message: response.message,
    data: response.data.items?.map(
      (item) =>
        ({
          code: item.code,
          name: item.name,
          slug: item.slug,
          favoriteCount: item.favorite_count,
          providerCode: item.provider_code,
          thumbnail: item.banner_url,
          rtp: item.rtp?.length > 0 ? item.rtp : null,
        } as Game),
    ),
  }
}
